// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function LongTextPreview(props) {
  var onChange = props.onChange;
  var language = props.language;
  var longText = props.longText;
  var handleOnchange = function ($$event) {
    var value = $$event.target.value;
    var firstChar = value[0];
    var check = Belt_Array.getBy([
          "<",
          "=",
          "+",
          "-",
          "@"
        ], (function (x) {
            return firstChar === x;
          }));
    if (check !== undefined || value.trim() === "") {
      return Curry._1(onChange, LongText$ReactHooksTemplate.setAnswer(longText, undefined));
    } else {
      return Curry._1(onChange, LongText$ReactHooksTemplate.setAnswer(longText, value));
    }
  };
  var onTitleChange = function (html) {
    Curry._1(onChange, LongText$ReactHooksTemplate.setText(longText, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, LongText$ReactHooksTemplate.setDescription(longText, html));
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                      text: LongText$ReactHooksTemplate.getTextTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language)),
                      description: LongText$ReactHooksTemplate.getDescriptionTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language)),
                      onTitleChange: onTitleChange,
                      onDescriptionChange: onDescriptionChange
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Input",
                              className: "text-aurometalsaurus text-sm mb-2 font-normal"
                            }),
                        JsxRuntime.jsx("textarea", {
                              className: "py-2 px-4 bg-alicebluepurple border-b border-gray-500 focus:border-gray-600 text-xs w-full",
                              placeholder: LongText$ReactHooksTemplate.getPlaceholderTranslation(longText, SurveyLanguage$ReactHooksTemplate.name(language)),
                              rows: 5,
                              value: Belt_Option.getWithDefault(LongText$ReactHooksTemplate.answer(longText), ""),
                              onChange: handleOnchange
                            })
                      ]
                    }),
                props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                        language: language
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ],
              className: "w-full p-16"
            });
}

var make = LongTextPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
